export default {
    meta: {
        title: '关联机会点',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
